module.exports = __webpack_public_path__ + "static/media/08_negro.88eb6a1e.svg";